export default "__VITE_ASSET__fbebe3c8__"